export default {
  inserted(el, binding) {
    const isLoading = binding.value

    if (isLoading) {
      el.classList.add('loading-Mantle')
      el.classList.add('loading-img')
      el.classList.add('p-relative')
    }
  },
  // When the bound element is updated with a new value...
  componentUpdated(el, binding) {
    // Get the value of the 'loading' directive
    const isLoading = binding.value

    // If the value is truthy, add the 'is-loading' class to the element
    if (isLoading) {
      el.classList.add('loading-Mantle')
      el.classList.add('loading-img')
      el.classList.add('p-relative')
    }

    // If the value is falsy, remove the 'is-loading' class from the element
    if (!isLoading) {
      el.classList.remove('loading-Mantle')
      el.classList.remove('loading-img')
    }
  },
}
